<div>
    <fa-icon *ngIf="!isEditing" [icon]="faEdit" (click)="onEditClick($event)"></fa-icon>
    <fa-icon *ngIf="isEditing" [icon]="faSave" (click)="onSaveClick()"></fa-icon>
    <fa-icon *ngIf="isEditing" [icon]="faCancel" (click)="onCancelClick()"></fa-icon>
</div>